import { MakeCall } from 'ha/services/apiV2/createMakeCall';

// eslint-disable-next-line sort-imports
import { APIV2_URL } from './constants';
import { RequestUserDocumentViewUrl } from './types/UserDocument';

export default (makeCall: MakeCall) => (
  userId: 'me' | number,
  docUUID: string,
) =>
  makeCall<RequestUserDocumentViewUrl>(
    'GET',
    `${APIV2_URL}/user/${userId}/document/${docUUID}/url`,
  );
